import { ApiError, storeConnectApi } from './api';

function getStoreConnectUrl(store: string, params?: object | URLSearchParams) {
  return storeConnectApi.request({
    method: 'GET',
    params,
    url: `/${store}/setup`,
    withCredentials: true,
  });
}

export { ApiError, getStoreConnectUrl };
